import React from 'react';
import classNames from 'classnames';

type IProps = {
  count: number;
  className?: string;
};

const CountBadge: React.FC<IProps> = ({ count, className = '' }) => (
  <div
    className={classNames([
      'app-sidebar__count-badge',
      {
        sm: count < 10,
        md: count >= 10 && count < 100,
        lg: count >= 100,
      },
      className,
    ])}
  >
    <span>{count < 100 ? count : '99+'}</span>
  </div>
);

export default CountBadge;
